import OffreProducteurRemiseModalController from './offre.producteur.remise.modal.controller';

import Template from './offre.producteur.remise.modal.html';
export default {
	bindings: {
		resolve: '=',
		modalInstance: '<'
	},
	template: Template,
	controller: OffreProducteurRemiseModalController
};
